import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CreateModal } from "../../../shared/components/Modal";
import { useGetUser } from "../hooks/useGetUsers";
import usePutUser from "../hooks/usePutUser";
import { Usuarios } from "../types/UsuariosTipo";
import { FormModalUser } from "./FormModalUser";

interface EditUserModalProps {
  onCancel: () => void;
  deleteModal: () => void;
  setUserId: any;
  visible: boolean;
  userId: number;
}

export function EditUserModal({onCancel, visible, userId, deleteModal, setUserId}: EditUserModalProps) {
  const [disabled, setDisabled] = useState<boolean>(true);
  const [user, setUser] = useState<Usuarios>();
  const {data: usuariosData} = useGetUser(userId);
  const { mutate: salvarEdicaoUsuario, isLoading: LoadingButton } = usePutUser(() => handleCloseLaterSave());

  const { register, handleSubmit, reset, formState: {errors} } = useForm<Usuarios>();

  useEffect(() => {
    usuariosData && setUser(usuariosData)
  }, [usuariosData]);

  async function onSubmit(data: Usuarios) {
    try {
      await salvarEdicaoUsuario({
        usuarioAtual: user ? user : usuariosData,
        userId, 
        data
      });
    } catch (error) {
      alert("Ocorreu um error: ");
    }
  }

  function handleCloseLaterSave() {
    setUserId(undefined)
    onCancel();
    reset();
    setDisabled(!disabled);
  }
  
  return (
    <>
    <CreateModal
      title="Editar Usuário"
      isModalOpen={visible}
      disabled={disabled}
      onCancel={onCancel}
      isLoading={LoadingButton}
      onSubmit={handleSubmit(onSubmit)}
      deleteOpenModal={() => {
        deleteModal();
      }}
      setDisabled={() => setDisabled(!disabled)}
      closable
      hasId
      buttonDelete
    >
      <FormModalUser 
        register={register} 
        disabled={disabled} 
        usuario={user} 
        errors={errors} 
        formEdit 
      />
    </CreateModal>
    </>
  );
}
